import { Remarkable } from 'remarkable';

const md = new Remarkable({
    html: false, // Enable HTML tags in source
    xhtmlOut: false, // Use '/' to close single tags (<br />)
    breaks: false, // Convert '\n' in paragraphs into <br>
    langPrefix: 'language-', // CSS language prefix for fenced blocks

    // Enable some language-neutral replacement + quotes beautification
    typographer: false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: '“”‘’',

    // Highlighter function. Should return escaped HTML,
    // or '' if the source string is not changed
    highlight(/* str, lang */) {
        return '';
    },
});

export const markdownToHtml = (markdown: string): string => {
    let html = md.render(markdown);

    // Remove paragraph around..
    if (html.startsWith('<p>')) {
        html = html.substring(3, html.length - 5);
    }

    console.log('markdowntoHTML', html);

    return html;
};

export function isEmpty(str: string | undefined): boolean {
    return str === undefined || str === null || str.trim().length === 0;
}

/**
 * Splits a string on semicolons ignoring any whitespace adjacent to the semicolons.
 * Slightly more human-proof than .split(';').  If string is empty returns [] which
 * is different than .split which returns [""].
 *
 * @param str
 * @returns
 */
export function splitOnSemicolon(str: string) {
    if (!str) return [];
    return str.split(/\s*;\s*/);
}

/**
 * @param str - The string to sanitize
 * @returns {string} - The sanitized string
 */
export const escapeForRegExp = (str: string): string =>
    str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export const cleanExtraSpaces = (str: string): string =>
    str === null || str === undefined ? '' : str.replace(/\s+/g, ' ').trim();

export function simplifyName(
    name: string | undefined,
    hideName: boolean
): string | undefined {
    if (!name) {
        return name;
    }

    // Morten Moeller => M. M.
    if (hideName) {
        return (
            name
                .trim()
                .toUpperCase()
                .split(' ')
                .filter((n) => n.trim().length > 0)
                .map((n) => n[0])
                .join('. ') + '.'
        );
    }

    // Morten Moeller => Morten M.
    return name
        .trim()
        .split(' ')
        .map((piece, index) =>
            index === 0
                ? piece
                : piece.length === 0
                ? undefined
                : piece.substring(0, 1).toUpperCase() + '.'
        )
        .filter((p) => !!p)
        .join(' ');
}
